// extracted by mini-css-extract-plugin
export default {"SegmentedControl":"txID49","segmentedControl":"txID49","stacked":"LhqFy1"};